import type { IconName } from '@fortawesome/fontawesome-svg-core';

import {
  ASSESSMENTS_DHA,
  BODY_SCAN,
  COUGH_SCAN,
  DEVICES,
  FACE_SCAN,
  IMAGING_TESTS,
  MANAGE_ACCESS_MANAGEMENT,
  SHARE_HISTORY,
  SKIN_SCAN,
} from './routes';

enum PlanType {
  Patient = 'Patient',
  Caregiver = 'Caregiver',
}

enum PlanFeature {
  HealthRecord = 'healthRecord',
  HealthDevices = 'healthDevices',
  Emr = 'emr',
  RecordSharing = 'recordSharing',
  UserAccessManagement = 'accessManagement',
  CaregiverUsers = 'caregivers',
  HealthScoresAchievements = 'healthScoresAchievements',
  Dha = 'dha',
  // Scans = 'scans',
  FaceScans = 'face',
  BodyScans = 'body',
  CoughScans = 'cough',
  SkinScans = 'skin',
  DiagnosticImages = 'diagnosticImages',
  PrimaryPractitionerRecords = 'primaryPractitionerRecords',
  // RelevantPractitionerRecords = 'relevantPractitionerRecords',
}

export const PLAN_TEXT = {
  NONE: {
    title: 'No Plan selected',
    description: '',
    summary: 'Member',
  },
  PATIENT: {
    title: 'Patient Account',
    description:
      'Your health information is collected and displayed in your own account for you to manage. You can manage other member’s accounts and authorize others to access your account.',
    summary: 'Personal (Account + Health Information)',
  },
  SECONDARY: {
    title: 'Dependant (Managed) Account',
    description:
      'This member’s health information is viewed and managed by a Caregiver or Personal Account member. A Dependant member may or may not be a minor, and does not access or manage their own health information.',
    summary: 'Dependant (Health Information Only)',
  },
  CAREGIVER: {
    title: 'User Account',
    description:
      'You do not store and manage your own personal health information. You view and manage the account and health information of the Dependant and Personal Accounts to which you are connected.',
    summary: 'User (Account Only)',
  },
};

const PLAN_FEATURE_MAP: Record<
  PlanFeature,
  { icon: { name: IconName }[]; route?: string }
> = {
  [PlanFeature.HealthRecord]: { icon: [{ name: 'clipboard-medical' }] },
  [PlanFeature.HealthDevices]: {
    icon: [{ name: 'watch-fitness' }],
    route: DEVICES,
  },
  [PlanFeature.Emr]: { icon: [{ name: 'laptop-medical' }] },
  [PlanFeature.RecordSharing]: {
    icon: [{ name: 'share-nodes' }],
    route: SHARE_HISTORY,
  },
  [PlanFeature.UserAccessManagement]: {
    icon: [{ name: 'user-shield' }],
    route: MANAGE_ACCESS_MANAGEMENT,
  },
  [PlanFeature.CaregiverUsers]: { icon: [{ name: 'user-nurse' }] },
  [PlanFeature.HealthScoresAchievements]: { icon: [{ name: 'trophy-star' }] },
  [PlanFeature.Dha]: {
    icon: [{ name: 'magnifying-glass-chart' }],
    route: ASSESSMENTS_DHA,
  },
  // [PlanFeature.Scans]: { icon: [{ name: 'expand' }] },
  [PlanFeature.FaceScans]: { icon: [{ name: 'smile' }], route: FACE_SCAN },
  [PlanFeature.BodyScans]: {
    icon: [{ name: 'expand' }, { name: 'person' }],
    route: BODY_SCAN,
  },
  [PlanFeature.CoughScans]: {
    icon: [{ name: 'head-side-cough' }],
    route: COUGH_SCAN,
  },
  [PlanFeature.SkinScans]: {
    icon: [{ name: 'person-dots-from-line' }],
    route: SKIN_SCAN,
  },
  [PlanFeature.DiagnosticImages]: {
    icon: [{ name: 'images' }],
    route: IMAGING_TESTS,
  },
  [PlanFeature.PrimaryPractitionerRecords]: { icon: [{ name: 'user-doctor' }] },
  // [PlanFeature.RelevantPractitionerRecords]: { icon: [{ name: 'hospital' }] },
};

export { PlanFeature, PlanType, PLAN_FEATURE_MAP };
